import React, { ReactNode, useState } from 'react';
import DialogContentText from '@mui/material/DialogContentText';

import { openModal, closeModal, Button } from '@p81-common/ui';

interface ModalProps {
  title?: string;
  callBack?: () => void | Promise<void>;
  text?: ReactNode;
  okText?: string;
  cancelText?: string;
}

const ModalButtons: React.FC<{
  okText: string;
  cancelText: string;
  callBack?: () => void | Promise<void>;
}> = ({ okText, cancelText, callBack }) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleOk = () => {
    if (isProcessing) {
      return;
    }
    setIsProcessing(true);
    callBack?.();
    closeModal();
  };

  const handleCancel = () => {
    if (!isProcessing) {
      closeModal();
    }
  };

  return (
    <>
      <Button color="secondary" onClick={handleCancel} disabled={isProcessing}>
        {cancelText}
      </Button>

      <Button onClick={handleOk} disabled={isProcessing}>
        {okText}
      </Button>
    </>
  );
};

export const modalActionBody = ({
  title,
  callBack,
  text,
  okText = 'Yes',
  cancelText = 'Cancel'
}: ModalProps) => {
  openModal({
    dialogTitleProps: {
      children: title
    },
    dialogContentProps: {
      children: <DialogContentText>{text}</DialogContentText>
    },
    dialogActionsProps: {
      children: (
        <ModalButtons
          okText={okText}
          cancelText={cancelText}
          callBack={callBack}
        />
      )
    }
  });
};
